module.exports = "/_next/static/images/bottom-banner-shopping-sp-db72ce5591ee63df1a4e68ee2072503b.jpg";